import { useNavigate } from 'react-router-dom';
import { Table, Tag } from 'rsuite';
import './CustomerTable.css';

import { useCustomers } from '../../hooks/useCustomers';

const { Column, HeaderCell, Cell } = Table;

const CustomerTable = () => {
    const { customers } = useCustomers({ sortByName: true });
    const navigate = useNavigate();

    return (
        <Table
            autoHeight
            data={customers}
            onRowClick={row => {
                navigate(`/customers/${row.id}`);
            }}
            rowClassName={rowData => {
                return rowData?.orphaned_but_has_project ? 'orphaned-customer-row' : '';
            }}
        >
            <Column align="left" fixed flexGrow={1} minWidth={160}>
                <HeaderCell>Name</HeaderCell>
                <Cell>
                    {rowData => (
                        <>
                            {rowData.name}
                            {rowData.orphaned_but_has_project && (
                                <span className="orphaned-label">
                                    {' '}
                                    (orphaned - removed from Procountor but has a project)
                                </span>
                            )}
                            {rowData.is_confidential && (
                                <Tag color="red" style={{ marginLeft: 5 }}>
                                    Confidential
                                </Tag>
                            )}
                        </>
                    )}
                </Cell>
            </Column>
            <Column align="left" fixed flexGrow={1} minWidth={160}>
                <HeaderCell>Integration Owner</HeaderCell>
                <Cell dataKey="integration_owner_name" />
            </Column>
        </Table>
    );
};

export default CustomerTable;
